module.exports = __webpack_public_path__ + "img/cpzz13@2x.df4ebbbe.png";